import {
  Accessibility,
  AccessibilityNewRounded,
  Co2,
  Diversity3,
  Female,
  Male,
  SpaOutlined,
} from '@mui/icons-material';
import { Box, ButtonBase, Chip } from '@mui/material';

import { language } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';
import { Fonts } from '@/ui/theme/fonts';
import { ScoreColor } from '@/ui/utils/get-color-for-score';

const SIZE = 36;

type TopicType = 'co2' | 'env' | 'ess' | 'women' | 'men' | 'other' | 'persons';

export function ScoreTag({
  value,
  colors,
  topic,
  orientation = 'horizontal',
  onClick,
  disabled,
}: {
  value: number | string;
  colors: ScoreColor;
  topic: TopicType;
  orientation?: 'horizontal' | 'vertical';
  onClick?: () => void;
  disabled?: boolean;
}) {
  if (onClick) {
    return (
      <ButtonBase
        onClick={onClick}
        disabled={disabled}
        sx={{
          borderRadius: 2,
          transition: 'opacity 0.15s',
          '&:hover': { opacity: 0.8 },
        }}
      >
        <ScoreTagContent
          value={value}
          colors={colors}
          topic={topic}
          orientation={orientation}
        />
      </ButtonBase>
    );
  }
  return (
    <ScoreTagContent
      value={value}
      colors={colors}
      topic={topic}
      orientation={orientation}
    />
  );
}

function ScoreTagContent({
  value,
  colors,
  topic,
  orientation,
}: {
  value: number | string;
  colors: ScoreColor;
  topic: TopicType;
  orientation: 'horizontal' | 'vertical';
}) {
  const icon = getTopicIcon(topic);
  return (
    <Box
      sx={{
        backgroundColor: ColorsRaw.anthracite.Warm_Anthracite_2,
        width: 'fit-content',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 2,
        flexDirection: orientation === 'vertical' ? 'column' : 'row',
      }}
    >
      {icon}
      <Chip
        sx={{
          color: colors.text,
          backgroundColor: colors.main,
          width: 'fit-content !important',
          minWidth: SIZE,
          height: SIZE,
          fontSize: 24,
          fontWeight: 'bold',
          fontFamily: Fonts.DarkerGrotesque,
        }}
        label={value.toLocaleString(language)}
      />
    </Box>
  );
}

function getTopicIcon(topic: TopicType) {
  const fontSize = SIZE;
  const py = 0.75;
  switch (topic) {
    case 'co2':
      return <Co2 sx={{ fontSize, py }} />;
    case 'env':
      return <SpaOutlined sx={{ fontSize, py }} />;
    case 'ess':
      return <Accessibility sx={{ fontSize, py }} />;
    case 'persons':
      return <AccessibilityNewRounded sx={{ fontSize, py }} />;
    case 'women':
      return <Female sx={{ fontSize, py }} />;
    case 'men':
      return <Male sx={{ fontSize, py }} />;
    case 'other':
      return <Diversity3 sx={{ fontSize, py }} />;
  }
}
